export const stripLocale = (url: string) => {
    const parsedUrl = new URL(url);
    parsedUrl.pathname = parsedUrl.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?\//, '/');
    return parsedUrl.toString();
};
